import { FC } from 'react';
import { Row, Col } from 'antd';
// import styles from '@/views/iterate/pages/siteselectionmap/components/AreaDetailDrawer/Charts/index.module.less';
import styles from '@/common/components/business/PassengerFlowPortrait/components/index.module.less';
import V2Title from '@/common/components/Feedback/V2Title';
// import BarChart from '@/views/iterate/pages/siteselectionmap/components/AreaDetailDrawer/Charts/BarChart';
import BarChart from '@/common/components/business/PassengerFlowPortrait/components/BarChart';
// import HistoryRate from '@/views/iterate/pages/siteselectionmap/components/AreaDetailDrawer/Charts/HistoryRate';
import HistoryRate from '@/common/components/business/PassengerFlowPortrait/components/HistoryRate';
// import { getDateTwoMonthsAgo } from '@/common/utils/ways';

// const dataLimit = getDateTwoMonthsAgo();

/**
 * @Description 业态&配套分析
 */
const TypeOfBusiness: FC<{
  detail: any;
}> = ({
  detail
}) => {

  return (
    <div className={styles.chartsContainer}>
      <V2Title divider type='H2' text='业态分析'
        extra={
          <span className={styles.tips}>数据更新时间截止{detail?.updateDataMonth || ''}，与当前开店数据不完全一致。</span>
        }
      />
      <div className={styles.desc}> {detail?.businessDistributionsIntro || '-'} </div>
      <Row gutter={16}>
        <Col span={12}>
          {detail?.businessDistributions
            ? <HistoryRate
              list={detail?.businessDistributions || []}
              historyList={detail?.historyBusinessDistributions || []}
            />
            : ''
          }
        </Col>
        <Col span={12}>
          <BarChart detail={detail}/>
        </Col>
      </Row>
    </div>
  );
};

export default TypeOfBusiness;
